// extracted by mini-css-extract-plugin
module.exports = {"pageError":"styles_pageError__2Baec"};